import { ErrorMessages } from '@types';
import { ZodError } from 'zod';

type InlineErrorMessageProps = {
  path: string | undefined;
  messages: ZodError | ErrorMessages[] | undefined;
};

export const InlineErrorMessage: React.FC<InlineErrorMessageProps> = (
  props,
) => {
  const { path = '', messages } = props;

  let errorMessage = '';
  let error;
  if (messages instanceof ZodError) {
    error = messages.issues.find((issue) => issue.path.includes(path));
  }

  if (messages instanceof Array) {
    error = messages.find((message) => message.path.includes(path));
  }

  errorMessage = error?.message || '';

  return errorMessage ? (
    <div
      data-testid="inline-error-message"
      className="border-status-error text-status-error text-body mb-2 border-l-[3px] pl-3 font-semibold"
    >
      {errorMessage}
    </div>
  ) : (
    <></>
  );
};
